/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for setOperation. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="setOperation"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="UNION"/&gt; &lt;enumeration value="INTERSECT"/&gt; &lt;enumeration value="EXCEPT"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SetOperation extends Enum{

	static  UNION = SetOperation.newLiteral("UNION");

	static  INTERSECT = SetOperation.newLiteral("INTERSECT");

	static  EXCEPT = SetOperation.newLiteral("EXCEPT");



	value() {
		return this.name();
	}

	static fromValue(v) {
		return SetOperation.valueOf(v);
	}

	getResourceId() {
		return (("SetOperation" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SetOperation.js